import React from "react";

import MenuIcon from "react-icons/lib/fa/ellipsis-v";

import { Manager, Reference, Popper } from "react-popper";

import { Card, Flex, Link } from "src/components";

import { ClickOutside } from "src/utils";

class Menu extends React.Component {
  static defaultProps = {
    placement: "left",
    renderToggle: ({ onClick, ref }) => (
      <Flex align="center" mx={2}>
        <div ref={ref}>
          <Link to="#" onClick={onClick} color="blue">
            <MenuIcon size={18} />
          </Link>
        </div>
      </Flex>
    ),
  };

  handleOpen = e => {
    e.preventDefault();
    this.props.onChangeOpen(true);
  };

  handleClose = () => {
    this.props.onChangeOpen(false);
  };

  render() {
    const { children, open, managerKey, renderToggle, placement } = this.props;

    return (
      <Manager key={managerKey}>
        <Reference>
          {({ ref }) =>
            renderToggle({
              ref,
              onClick: this.handleOpen,
            })
          }
        </Reference>
        {open ? (
          <Popper placement={placement}>
            {({ ref, style, placement }) => (
              <div ref={ref} style={style} data-placement={placement}>
                <ClickOutside onClickOutside={this.handleClose}>
                  <Card m={2} minWidth={150}>
                    {children}
                  </Card>
                </ClickOutside>
              </div>
            )}
          </Popper>
        ) : null}
      </Manager>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/banking/components/Menu/Menu.js